import { AVAILABILITY_STATUS_IN_STOCK } from '@api/catalog/product/catalogSearchParams';

import { fromRoubleToKopecks } from '@scripts/helpers';

import { FilterValue, FormValues, PriceRange } from '../../types';
import { isPriceRangeDefault } from '../../utils';
import { normalizeFieldName } from '../../utils/fieldNames';
import { isNumberArray } from '../../utils/helpers';

export const transformPopupIsPreOrderToIsPreOrder = (
    values: Record<string, FilterValue>,
    fieldPrefix?: string
): Record<string, FilterValue> => {
    const isPreOrderFieldName = fieldPrefix ? `${fieldPrefix}_popup_isPreOrder` : 'popup_isPreOrder';
    const targetIsPreOrderFieldName = fieldPrefix ? `${fieldPrefix}_isPreOrder` : 'isPreOrder';
    const popupIsPreOrderValue = values[isPreOrderFieldName];

    const transformedValues = { ...values };

    delete transformedValues[isPreOrderFieldName];
    if (popupIsPreOrderValue !== undefined) {
        transformedValues[targetIsPreOrderFieldName] = popupIsPreOrderValue;
    }

    return transformedValues;
};

export const processFormValuesToFilters = (
    values: FormValues,
    fieldPrefix?: string,
    baseFilters?: FormValues
): FormValues => {
    const filters: FormValues = { ...(baseFilters || {}) };

    Object.keys(values).forEach(key => {
        const fieldName = normalizeFieldName(key, fieldPrefix);
        const value = values[key];

        if (value === undefined || value === null) return;

        if (fieldName === 'price' && isNumberArray(value)) {
            filters.price_gte = fromRoubleToKopecks(value[0]);
            filters.price_lte = fromRoubleToKopecks(value[1]);

            return;
        }

        if (Array.isArray(value)) {
            if (value.length > 0) {
                filters[fieldName] = value;
            } else {
                delete filters[fieldName];
            }

            return;
        }

        if (typeof value === 'boolean') {
            if (fieldName === 'isPreOrder') {
                if (value) {
                    filters.availability_status = [AVAILABILITY_STATUS_IN_STOCK];
                } else {
                    delete filters.availability_status;
                }
            } else {
                if (value) {
                    filters[fieldName] = value;
                } else {
                    delete filters[fieldName];
                }
            }

            return;
        }

        filters[fieldName] = value;
    });

    if (baseFilters) {
        Object.keys(baseFilters).forEach(key => {
            if (['category_id', 'virtual_category_id', 'seller_id', 'query'].includes(key)) {
                filters[key] = baseFilters[key];
            } else if (key === 'brand_id') {
                const brandFieldName = fieldPrefix ? `${fieldPrefix}_brand_id` : 'brand_id';
                if (
                    !values[brandFieldName] ||
                    (Array.isArray(values[brandFieldName]) && values[brandFieldName].length === 0)
                ) {
                    filters[key] = baseFilters[key];
                }
            }
        });
    }

    return filters;
};

export const processPriceFilter = (
    values: Record<string, FilterValue>,
    fieldPrefix: string | undefined,
    priceRange: PriceRange | undefined,
    rememberedPrice: number[] | undefined
): void => {
    const priceFieldName = fieldPrefix ? `${fieldPrefix}_price` : 'price';
    const currentPrice: number[] | undefined = isNumberArray(values[priceFieldName])
        ? values[priceFieldName]
        : undefined;

    const isValidRememberedPrice =
        rememberedPrice &&
        Array.isArray(rememberedPrice) &&
        rememberedPrice.length === 2 &&
        !isPriceRangeDefault(rememberedPrice[0], rememberedPrice[1], priceRange);

    if (currentPrice) {
        const [min, max] = currentPrice;
        if (isPriceRangeDefault(min, max, priceRange)) {
            if (isValidRememberedPrice) {
                values[priceFieldName] = rememberedPrice;
            } else {
                delete values[priceFieldName];
            }
        }
    } else {
        if (isValidRememberedPrice) {
            values[priceFieldName] = rememberedPrice;
        }
    }
};
